import React, { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import './TextDiff.css'
import { diffLines, diffStats } from './utils/diffTool'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const TextDiff = () => {
  useDocumentMeta({
    title: 'Comparador de Texto (Diff) | jarder.dev',
    description:
      'Compare dois textos linha a linha e veja o que foi adicionado ou ' +
      'removido. Grátis, direto no navegador, sem enviar nada pra servidor.',
  })

  const [textA, setTextA] = useState('')
  const [textB, setTextB] = useState('')
  const [result, setResult] = useState(null)

  const stats = useMemo(() => (result ? diffStats(result) : null), [result])

  const compare = () => {
    setResult(diffLines(textA, textB))
    trackEvent('tool_generate', { tool: 'text_diff' })
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Comparador de Texto (Diff)</h1>
      <p className="tool-disclaimer">
        Tudo processado localmente no seu navegador, nenhum texto é
        enviado para nenhum servidor.
      </p>

      <div className="tool-row">
        <div className="tool-field">
          <label htmlFor="text-a">Texto original</label>
          <textarea
            id="text-a"
            rows="10"
            value={textA}
            onChange={(e) => setTextA(e.target.value)}
          />
        </div>
        <div className="tool-field">
          <label htmlFor="text-b">Texto novo</label>
          <textarea
            id="text-b"
            rows="10"
            value={textB}
            onChange={(e) => setTextB(e.target.value)}
          />
        </div>
      </div>

      <button type="button" className="tool-button" onClick={compare}>
        Comparar
      </button>

      {result && (
        <div style={{ marginTop: 24 }}>
          <p className="tool-import-hint">
            +{stats.added} adicionadas, -{stats.removed} removidas
          </p>
          <div className="text-diff-output">
            {result.map((line, i) => (
              <div key={i} className={`text-diff-line text-diff-${line.type}`}>
                <span className="text-diff-marker">
                  {line.type === 'added' ? '+' : line.type === 'removed' ? '-' : ' '}
                </span>
                <span className="text-diff-content">{line.value || ' '}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="tool-info-section">
        <h2>Como a comparação funciona</h2>
        <p>
          A ferramenta compara os dois textos linha a linha e marca o
          que foi adicionado (+), removido () ou permaneceu igual.
          Útil para revisar mudanças em um contrato, comparar versões de
          um texto, conferir o que mudou entre dois trechos de código ou
          identificar diferenças em arquivos de configuração sem usar
          Git.
        </p>
      </div>
    </div>
  )
}

export default TextDiff
